import { Provider } from 'react-redux';

import CoreLoader from './components/utils/CoreLoader.js';
import firebaseConfig from './config/credentials/firebase';
import LAYOUT from './config/layout/general';
import PRESETS from './config/layout/presets';
import THEME from './config/layout/theme/defaultConfig.js';
import COLORS from './config/layout/colors';
import routes, { routesO } from './config/routes'; // Route list
import Userform from './config/Userform';
import Caseform from './config/Caseform';
import APPCONFIG from './config/appconfig';

import logo from './assets/logo.png';
import placeholder from './assets/placeholder.png';
import { store } from './redux/store.js';
import ApiService from './services/ApiService.js';

function App() {
  const apiService = new ApiService("");

  const configFiles = {
    firebaseConfig: process.env.REACT_APP_FIREBASE_CONFIG && JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG) || firebaseConfig,
    APPCONFIG,
    LAYOUT,
    PRESETS,
    THEME,
    COLORS,
    routes,
    routesO,
    Userform,
    Caseform,
    logo,
    placeholder,
    getConfigFile,
    apiService,
  }

  return (
    <Provider store={store}>
      <CoreLoader configFiles={configFiles}/>
    </Provider>
  );
}

export default App;

const getConfigFile = async (path) => {
  let result;

  try{
    result = await import('./config/'+path);
  }
  catch(e){
    result = false;
  }

  return result;
}